import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/vars';
  @import 'src/common/styling/_mixins-scss/rem';

  .ClientAnalyticsPage {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 24px;

    &__filters {
      display: flex;
      width: 100%;
      gap: 24px;

      @include respond-to(sm) {
        flex-direction: column;
        gap: 16px;
      }

      .BaseSelectField {
        flex: 1;
        margin-bottom: 0;
      }
    }

    &__analytics {
      display: flex;
      width: 100%;
      gap: 24px;

      @include respond-to(sm) {
        flex-direction: column;
        gap: 16px;
      }

      &-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: #fff;
        border-radius: 3px;
        padding: 24px;

        &:last-child {
          justify-content: space-between;
        }

        &-metric {
          display: flex;
          justify-content: space-between;
          align-items: center;

          &:first-child {
            margin-bottom: 4px;
          }

          &-title {
            font-size: 14px;
            color: #9c9c9c;

            &-main {
              color: #000;
              font-size: 20px;
            }
          }

          &-value {
            font-size: 14px;

            .MoneyCell__inner {
              height: fit-content;
            }

            &-main {
              font-weight: 500;
              font-size: 20px;
              .MoneyCell__inner {
                height: fit-content;
              }
            }
          }
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .ClientAnalyticsPage {
      &__analytics {
        &-item {
          background-color: ${colors.white.hex};
          border-radius: ${border.radius};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
